var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15.5553137px",
    viewBox: "0 0 14 15.5553137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LeadBust",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---Yes-Copy",
    transform: "translate(-1349, -456)",
    fill: "#818181",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(770, 439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy",
    transform: "translate(579, 17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51994711,0 L6.49114172,0 C5.11898601,0 4.0321176,0 3.18151344,0.114799492 C2.30610608,0.232966613 1.59756224,0.481939674 1.03878645,1.04296322 C0.480018447,1.603979 0.232033158,2.31536949 0.114340479,3.19429238 C0,4.04831097 0,5.13954269 0,6.51719725 L0,11.0575276 C0,12.2304877 0.715512695,13.2356822 1.73223371,13.6570798 C1.67990511,12.9497726 1.679944,11.9572559 1.67999067,11.1314938 L1.67999067,7.30920397 L1.67999067,7.23515993 C1.67993623,6.23828769 1.67988178,5.37942358 1.77198571,4.69161518 C1.87069294,3.95449594 2.09329171,3.24791986 2.66410742,2.67480971 C3.23492314,2.10169179 3.9386759,1.87820636 4.67284738,1.77910247 C5.35790246,1.68663298 6.21339882,1.68667965 7.20622663,1.68673409 L7.27995956,1.68674187 L9.51994711,1.68674187 L9.59368004,1.68673409 C10.5865079,1.68667965 11.4401142,1.68663298 12.1251771,1.77910247 C11.7153682,0.737166034 10.7034072,0 9.51994711,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80006222,7.30904841 C2.80006222,5.18867464 2.80006222,4.12849941 3.45613747,3.46978752 C4.11221271,2.81107562 5.16815685,2.81107562 7.28003733,2.81107562 L9.52002489,2.81107562 C11.6319132,2.81107562 12.6878184,2.81107562 13.3439481,3.46978752 C14,4.12849941 14,5.18868241 14,7.30904841 L14,11.057372 C14,13.177738 14,14.237921 13.3439481,14.8966174 C12.6878184,15.5553137 11.6319132,15.5553137 9.52002489,15.5553137 L7.28003733,15.5553137 C5.16815685,15.5553137 4.11221271,15.5553137 3.45613747,14.8966174 C2.80006222,14.237921 2.80006222,13.177738 2.80006222,11.057372 L2.80006222,7.30904841 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.20b082b913eaf02f9d01cac778df6213.svg";
export { ForwardRef as ReactComponent };